import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toaster } from 'react-hot-toast';
import './index.css';
import App from './App';
import { ConfirmProvider } from './components/ConfirmDialog';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfirmProvider>
      <App />
      <Toaster position="top-right" gutter={8} />
    </ConfirmProvider>
  </React.StrictMode>
);
